export default __webpack_public_path__ + "static/media/background-whitegrunge.ef40408e.jpg";